var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSourceCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M426.667 902.095h85.333l85.333-780.19h-85.333l-85.333 780.19zM243.5 264.635l-243.5 247.365 243.5 247.365 60.334-61.289-183.166-186.075 183.166-186.074-60.334-61.291zM720.165 325.926l60.333-61.291 243.502 247.365-243.502 247.365-60.333-61.289 183.17-186.075-183.17-186.074z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceCode);
export default __webpack_public_path__ + "static/media/source-code.86c30ca49f77346b23051c5c8818e3be.svg";
export { ForwardRef as ReactComponent };